import React from 'react'
import PropTypes from 'prop-types'
import Input from './Input.jsx'

export default class RadioListInput extends Input {
  static propTypes = {
    options: PropTypes.object,
  }

  static defaultProps = {
    options: {}
  }

  render () {
    return (
      <div className="radiolist">
        {Object.keys(this.props.options).map((key) => {
          return (
            <label key={key}>
              <input
                type="radio"
                name={this.props.name}
                value={key}
                checked={this.props.value.toString() === key}
                onChange={this.handleChange}
              />
              {this.props.options[key]}
            </label>
          )
        })}
      </div>
    )
  }
}
